import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";




export const unitMeasurementCategory = agroApi.injectEndpoints({
    endpoints: (builder) => ({
 
        getUnitMeasurementCategory: builder.query<ResponseDataTest<EntDirectoryInfoName[]>, void>({
          query: () => ({
              url: `/hb-unit-measurement/all-categories`,
              method: 'GET'
          })
      })
     
    }),
    overrideExisting: false,
});

export const {
  useGetUnitMeasurementCategoryQuery
} = unitMeasurementCategory;
